import { render, staticRenderFns } from "./BindCarousel.vue?vue&type=template&id=5532f194&scoped=true"
import script from "./BindCarousel.vue?vue&type=script&lang=js"
export * from "./BindCarousel.vue?vue&type=script&lang=js"
import style0 from "./BindCarousel.vue?vue&type=style&index=0&id=5532f194&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0_n2ycmw2hd7odnkbow3ucmwrsku/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5532f194",
  null
  
)

export default component.exports